module.exports = __webpack_public_path__ + "kameon-icons.c0a52c625f3739aee170.woff";


//////////////////
// WEBPACK FOOTER
// C:/GIT/kameon.gdpr/ui/src/assets/fonts/kameon-icons.woff?v=0.1.0
// module id = ../../../../../src/assets/fonts/kameon-icons.woff?v=0.1.0
// module chunks = styles